/*
 * Copyright (c) 2020, Neustar, Inc.
 * UNPUBLISHED PROPRIETARY SOURCE CODE
 *
 */

const localConfig = {
  contextPath: '/idmp',
  redirectOnLogout: false
}

// making this work with both es6 and commonjs so that
// it can be used in webpack.config.js to be passed into
// index.ejs
//export default localConfig;
module.exports = localConfig;
